export namespace CompanyNs {

  export enum PropertyEnums {
    COMPANY = 'companyName',
    COMPANY_EMAIL = 'companyEmail',

    ORGANIZATION = 'organization',
    COMPANY_SIZE = 'companySize',
    BUSS_FOCUS = 'target',
    INDUSTRY = 'industry',
    TECH_STACK = 'tachStack',
    LEGAL = 'legalNotice',
    FOUNDED = 'founded',
    PROJECT_SIZE = 'projectSize',
    DESCRIPTION = 'description',

    PRODUCT_HUNT = 'productHunt',
    CLUTCH_CO = 'clutchCo',
    ANGEL_CO = 'angelCo',
    CRUNCH_BASE = 'crunchBase',

    CITY = 'city',
    COUNTRY = 'country',

    PHONE = 'phone',
    MOBILE = 'mobile',
    EMAIL = 'email',
    WEBSITE = 'website',

    LINKEDIN = 'linkedin',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    YOUTUBE = 'youtube',
    WHATSAPP = 'whatsapp',
    TELEGRAM = 'telegram',
  }

}
